import {buildAuthenticationHeaders, dashboardAxios} from './global';

const getOtpState = (brandId, credentials) =>
    dashboardAxios.get(`/messages-10dlc/api/account/${credentials.accountId}/otp/${brandId}`, {
        ...buildAuthenticationHeaders(credentials)
    });

const requestOtp = (brandId, credentials) =>
    dashboardAxios.post(`/messages-10dlc/api/account/${credentials.accountId}/otp/${brandId}/start`, {}, {
        ...buildAuthenticationHeaders(credentials)
    });

const sendOtp = (brandId, credentials, otpCode) =>
    dashboardAxios.post(`/messages-10dlc/api/account/${credentials.accountId}/otp/${brandId}/send`, { otp_pin: otpCode }, {
        ...buildAuthenticationHeaders(credentials)
    });

export {
    getOtpState,
    requestOtp,
    sendOtp,
};
